import React from 'react'
import PropTypes from 'prop-types'

const PreviewPauseIcon = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Play/Pause">
      <rect id="Rectangle 1521" x="1.17188" y="0.75" width="38.5" height="38.5" rx="19.25" fill="#151515" fillOpacity="0.6" stroke="currentColor" strokeWidth="1.5" />
      <g id="Group 134">
        <rect id="Rectangle 1522" x="13.9219" y="12" width="4" height="16" rx="1" fill="currentColor" />
        <rect id="Rectangle 1523" x="22.9219" y="12" width="4" height="16" rx="1" fill="currentColor" />
      </g>
    </g>
  </svg>
)

PreviewPauseIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

PreviewPauseIcon.defaultProps = {
  width: 41,
  height: 40,
  title: 'Menu',
}

export default PreviewPauseIcon
